import { Route, Switch, useHistory, useRouteMatch } from "react-router-dom";
import NestedSideNavigation from "../../components/organism/NestedSideNavigation";
import NotificationSettingsLayout from "./NotificationsSettingsLayout";
import OrganisationSettings from "./OrganisationSettings";
import { useEffect } from "react";
import PersonalSettings from "./PersonalSettings";
import useProfile from "../../services/utils/custom hooks/useProfile";
import CustomNavLinkProps from "../../services/models/customNavLinkProps.model";

function NotificationsSettingsPage() {
  const match = useRouteMatch();
  const profile = useProfile();
  const isPhysicianOnly =
    profile?.data?.user?.roles?.includes("Physician") &&
    profile?.data?.user?.roles?.length === 1;
  const links = [
    isPhysicianOnly
      ? null
      : {
          to: `${match.path}/organizations-settings`,
          name: "Organization Settings",
          isExact: false,
        },
    {
      to: `${match.path}/personal-settings`,
      name: "Personal Settings",
      isExact: false,
    },
  ].filter((link): link is CustomNavLinkProps => !!link);

  return (
    <NotificationSettingsLayout>
      <NestedSideNavigation links={links} />
      <div className="overflow-auto xs:row-span-2 md:row-span-1">
        <Switch>
            <Route
              path={`${match.path}/organizations-settings`}
              component={OrganisationSettings}
            />
          <Route
            path={`${match.path}/personal-settings`}
            component={PersonalSettings}
          />
        </Switch>
      </div>
    </NotificationSettingsLayout>
  );
}


export default NotificationsSettingsPage;
